import { ChapterManageList } from './ChapterManageList'
import { withChapterManageList } from './withChapterManageList'

const ConnectedChapterManageList = withChapterManageList(ChapterManageList)

export { ConnectedChapterManageList as ChapterManageList }
